export const UKRANIAN = 'UA';
